import { render, staticRenderFns } from "./NotAvailableTag.vue?vue&type=template&id=3326a8d3&"
import script from "./NotAvailableTag.vue?vue&type=script&lang=js&"
export * from "./NotAvailableTag.vue?vue&type=script&lang=js&"
import style0 from "./NotAvailableTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports